import logoIconSrc from '@/assets/bunker-ai-logo-icon.png';

interface BunkerMarkProps {
  /** Rendered size in px (width = height). */
  size?: number;
  className?: string;
  /** Accessible label. When provided, the mark is exposed as an image with this
   *  alt text; otherwise it is hidden from assistive tech (decorative). */
  title?: string;
}

/**
 * Bunker AI brand mark — the real bunker.ai product logo (the polished
 * navy-to-electric-blue shield with circuit traces and a padlock), copied from
 * the custom-rag product repo (`assets/bunker-ai-logo-icon.png`).
 *
 * Rendered as a transparent-background `<img>` so it matches the product UI
 * exactly. Keeps the original BunkerMark API (size / className / title) so every
 * call site (sidebar rail, Start wordmark, chat avatar) is unchanged.
 */
export function BunkerMark({ size = 28, className, title }: BunkerMarkProps) {
  return (
    <img
      src={logoIconSrc}
      width={size}
      height={size}
      className={className}
      alt={title ?? ''}
      aria-hidden={title ? undefined : true}
      draggable={false}
      style={{ objectFit: 'contain', display: 'block' }}
    />
  );
}
